import React from "react";
import { BOARD } from "../../data/board";

const MARKS = [
  { id: "c0", kind: "classified", left: 360, top: 300, rotate: -18 },
  { id: "n0", kind: "confidential", left: 1010, top: 1560, rotate: 14 },
  { id: "c1", kind: "classified", left: 3300, top: 220, rotate: -12 },
  { id: "n1", kind: "confidential", left: 2560, top: 1460, rotate: -9 },
  { id: "c2", kind: "classified", left: 800, top: 2880, rotate: 16 },
  { id: "n2", kind: "confidential", left: 3300, top: 3120, rotate: -14 },
  { id: "c3", kind: "classified", left: 2880, top: 3040, rotate: -14 },
];

const ClassifiedStamp = ({ id }) => {
  const top = `${id}-arc-top`;
  const bottom = `${id}-arc-bot`;

  return (
    <svg className="board-stamp-svg" viewBox="0 0 180 180" aria-hidden="true">
      <circle cx="90" cy="90" r="84" fill="none" stroke="currentColor" strokeWidth="7" />
      <circle cx="90" cy="90" r="74" fill="none" stroke="currentColor" strokeWidth="2.2" />
      <circle cx="90" cy="90" r="36" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="3 5" />
      <path id={top} d="M 32 90 A 58 58 0 0 1 148 90" fill="none" />
      <path id={bottom} d="M 148 90 A 58 58 0 0 1 32 90" fill="none" />
      <text className="board-stamp-arc">
        <textPath href={`#${top}`} startOffset="50%" textAnchor="middle">
          CLASSIFIED
        </textPath>
      </text>
      <text className="board-stamp-arc board-stamp-arc--sub">
        <textPath href={`#${bottom}`} startOffset="50%" textAnchor="middle">
          RESTRICTED ACCESS
        </textPath>
      </text>
      <text className="board-stamp-star" x="90" y="98" textAnchor="middle">
        ★
      </text>
    </svg>
  );
};

const ConfidentialStamp = () => (
  <span className="board-stamp-plate">
    <span className="board-stamp-plate-inner">
      <span className="board-stamp-stars" aria-hidden="true">
        ★ ★ ★
      </span>
      <span className="board-stamp-word">CONFIDENTIAL</span>
      <span className="board-stamp-sub">DO NOT COPY</span>
    </span>
  </span>
);

export const BoardWatermarks = () => (
  <div className="board-watermarks" aria-hidden="true" style={{ width: BOARD.width, height: BOARD.height }}>
    {MARKS.map((mark) => (
      <span
        key={mark.id}
        className={`board-watermark board-watermark--${mark.kind}`}
        style={{
          left: mark.left,
          top: mark.top,
          "--stamp-rotate": `${mark.rotate}deg`,
        }}
      >
        {mark.kind === "classified" ? <ClassifiedStamp id={mark.id} /> : <ConfidentialStamp />}
      </span>
    ))}
  </div>
);

export default BoardWatermarks;
